var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"fs-13 color-danger error-msg",staticStyle:{"height":"13px","width":"100%"}},[_vm._v(_vm._s(_vm.props.error))])}
var staticRenderFns = []

export { render, staticRenderFns }